import { render, staticRenderFns } from "./ActiveBasicLayoutIcon.vue?vue&type=template&id=40db73f9"
import script from "./ActiveBasicLayoutIcon.vue?vue&type=script&lang=js"
export * from "./ActiveBasicLayoutIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports